export const MULTIVIEW_LIMITS = {
  maxFeeds: 16,
} as const

export const MULTIVIEW_TIMINGS = {
  sessionStatusPollInterval: 15000,
} as const

export const FALLBACK_SESSION_COLOR = '#718096'

// 16 distinct colors using OKLCH - evenly spaced hues (22.5° apart) with consistent lightness/chroma
export const SESSION_COLORS = [
  'oklch(60% 0.15 0)', // red
  'oklch(60% 0.15 22.5)', // red-orange
  'oklch(60% 0.15 45)', // orange
  'oklch(60% 0.15 67.5)', // yellow-orange
  'oklch(60% 0.15 90)', // yellow
  'oklch(60% 0.15 112.5)', // yellow-green
  'oklch(60% 0.15 135)', // lime
  'oklch(60% 0.15 157.5)', // green
  'oklch(60% 0.15 180)', // teal
  'oklch(60% 0.15 202.5)', // cyan
  'oklch(60% 0.15 225)', // sky blue
  'oklch(60% 0.15 247.5)', // blue
  'oklch(60% 0.15 270)', // indigo
  'oklch(60% 0.15 292.5)', // purple
  'oklch(60% 0.15 315)', // magenta
  'oklch(60% 0.15 337.5)', // pink
] as const
